import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import PF2StatusUpdateModalUI from './PF2StatusUpdateModalUI.js'

class PF2StatusUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,

            processingFeeStatus: '',
            tdsAmount: ''
        }
    }

    componentDidMount() {
        Modal.setAppElement('body')
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.updateMode && this.props.updateMode) {
            this.initializeForm()
        }
    }

    initializeForm = () => {
        const allStatuses = [
            { key: 'unpaid', value: 'unpaid' },
            { key: 'waived', value: 'waived' },
        ]

        const currentStatus = this.props.loan.procFee2Status

        const filtered = allStatuses.filter(
            status => status.key !== currentStatus
        )

        this.setState({
            processingFeeStatus: filtered.length > 0 ? filtered[0].key : '',
            tdsAmount: '',
            errorList: null,
            successMsg: null,
            submitted: false
        })
    }

    render() {
        const allStatuses = [
            { key: 'unpaid', value: 'unpaid' },
            { key: 'waived', value: 'waived' },
        ]

        const currentStatus = this.props.loan.procFee2Status

        const processingFeeStatusList = allStatuses.filter(
            status => status.key !== currentStatus
        )

        return (
            <PF2StatusUpdateModalUI
                loan={this.props.loan}
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}

                updateMode={this.props.updateMode}
                submitted={this.state.submitted}

                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelClick}

                processingFeeStatus={this.state.processingFeeStatus}
                onProcessingFeeStatusChange={(e) =>
                    this.setState({ processingFeeStatus: e.target.value })
                }
                processingFeeStatusList={processingFeeStatusList}

                tdsAmount={this.state.tdsAmount}
                onTdsAmountChange={(e) =>
                    this.setState({ tdsAmount: e.target.value })
                }
            />
        )
    }

    onSubmit = () => {
        if (this.state.submitted) return

        let errorList = []

        // ✅ VALIDATIONS
        if (!this.state.processingFeeStatus) {
            errorList.push('Processing Fee Status is required')
        }

        if (!this.state.tdsAmount) {
            errorList.push('TDS Amount is required')
        } else if (isNaN(this.state.tdsAmount)) {
            errorList.push('TDS Amount must be numeric')
        }

        // ❌ STOP if errors
        if (errorList.length > 0) {
            this.setState({ errorList })
            return
        }

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(
            this.props.context,
            `/api/su/loans/${this.props.loan.loanId}/processingFees/2/status`,
            this.onSubmitCallback,
            {
                procFeeStatus: this.state.processingFeeStatus,
                tdsAmountF: this.state.tdsAmount
            }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []

        if (response && response.errorList) {
            response.errorList.forEach(error => {
                errorList.push(error.message)
            })
        }

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (!response.errorList || response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList })
    }
}

export default withRouter(PF2StatusUpdateModalSF)